module.exports = __webpack_public_path__ + "static/media/Memory_App.e6bfb806.png";